import React, { createContext, useReducer, useEffect } from "react";
import BuildReducer from "./BuildReducer";

const initialState = {
  stage: 0,
  lastCompleted: 0,
  type: '',
  isLoading: false,
  name: '',
  headline: '',
  ctaText: '',
  ctaUrl: '',
  primaryColor: '',
  secondaryColor: '#fefefe',
  fileName: '',
  fileUrl: '',
  pages: [],
  utm_source: '',
  utm_medium: '',
  utm_term: '',
  utm_content: '',
  utm_campaign: '',
  queryParameters: [],
};

export const BuildContext = createContext(initialState);

//----------------------------------------------------------------------------
const localState = JSON.parse(localStorage.getItem("buildState"));

export const BuildProvider = ({ children }) => {
  const [state, dispatch] = useReducer(BuildReducer, localState || initialState);

  useEffect(() => {
    localStorage.setItem("buildState", JSON.stringify(state));
  }, [state]);

  // Actions
  function setStage(stage) {
    dispatch({
      type: 'SET_STAGE',
      stage,
    })
  }

  function setLastCompleted(lastCompleted) {
    dispatch({
      type: 'SET_LAST_COMPLETED',
      lastCompleted,
    })
  }

  function setType(newType) {
    dispatch({
      type: 'SET_TYPE',
      newType,
    })
  }

  function setIsLoading(isLoading) {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading,
    })
  }

  function setName(name) {
    dispatch({
      type: 'SET_NAME',
      name,
    })
  }

  function setHeadline(headline) {
    dispatch({
      type: 'SET_HEADLINE',
      headline,
    })
  }

  function setCtaText(ctaText) {
    dispatch({
      type: 'SET_CTA_TEXT',
      ctaText,
    })
  }

  function setCtaUrl(ctaUrl) {
    dispatch({
      type: 'SET_CTA_URL',
      ctaUrl,
    })
  }

  function setPrimaryColor(primaryColor) {
    dispatch({
      type: 'SET_PRIMARY_COLOR',
      primaryColor,
    })
  }

  function setSecondaryColor(secondaryColor) {
    dispatch({
      type: 'SET_SECONDARY_COLOR',
      secondaryColor,
    })
  }

  function setFileName(fileName) {
    dispatch({
      type: 'SET_FILE_NAME',
      fileName,
    })
  }

  function setFileUrl(fileUrl) {
    dispatch({
      type: 'SET_FILE_URL',
      fileUrl,
    })
  }

  function setPage(page, i) {
    dispatch({
      type: 'SET_PAGE',
      page,
      i
    })
  }

  function setUtmSource(utm_source) {
    dispatch({
      type: 'SET_UTM_SOURCE',
      utm_source,
    })
  }

  function setUtmMedium(utm_medium) {
    dispatch({
      type: 'SET_UTM_MEDIUM',
      utm_medium,
    })
  }

  function setUtmCampaign(utm_campaign) {
    dispatch({
      type: 'SET_UTM_CAMPAIGN',
      utm_campaign,
    })
  }

  function setUtmTerm(utm_term) {
    dispatch({
      type: 'SET_UTM_TERM',
      utm_term,
    })
  }

  function setUtmContent(utm_content) {
    dispatch({
      type: 'SET_UTM_CONTENT',
      utm_content,
    })
  }

  function setQueryParameter(queryParameter, i) {
    dispatch({
      type: 'SET_QUERY_PARAMETER',
      queryParameter,
      i
    })
  }

  function setCurrentSpotlight(currentSpotlight) {
    dispatch({
      type: 'SET_CURRENT_SPOTLIGHT',
      currentSpotlight,
    });
  }

  function clear() {
    dispatch({
      type: 'CLEAR',
      initialState,
    });
  }

  const colorOptions = [
    "#2bcc7d",
    "#4996e9",
    "#1E3290",
    "#003f5c",
    "#4a154b",
    "#bc5090",
    "#ff6361",
    "#ffa600",
    "#FE7323",
    "#211D20",
  ];

  const generateRandomColor = () => {
    return colorOptions[Math.floor(Math.random() * colorOptions.length)];
  };

  return (
    <BuildContext.Provider
      value={{
        stage: state.stage,
        lastCompleted: state.lastCompleted,
        type: state.type,
        isLoading: state.isLoading,
        name: state.name,
        headline: state.headline,
        ctaText: state.ctaText,
        ctaUrl: state.ctaUrl,
        primaryColor: state.primaryColor,
        secondaryColor: state.secondaryColor,
        fileName: state.fileName,
        fileUrl: state.fileUrl,
        pages: state.pages,
        utm_source: state.utm_source,
        utm_medium: state.utm_medium,
        utm_term: state.utm_term,
        utm_content: state.utm_content,
        utm_campaign: state.utm_campaign,
        queryParameters: state.queryParameters,

        setStage,
        setLastCompleted,
        setType,
        setIsLoading,
        setName,
        setHeadline,
        setCtaText,
        setCtaUrl,
        setPrimaryColor,
        setSecondaryColor,
        setFileName,
        setFileUrl,
        setPage,
        setUtmSource,
        setUtmMedium,
        setUtmTerm,
        setUtmContent,
        setUtmCampaign,
        setQueryParameter,
        setCurrentSpotlight,

        clear,
        colorOptions,
        generateRandomColor,
      }}
    >
      {children}
    </BuildContext.Provider>
  );
};
